import { render, staticRenderFns } from "./TourGeneralInfo.vue?vue&type=template&id=b53c119a&scoped=true&"
import script from "./TourGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./TourGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./TourGeneralInfo.vue?vue&type=style&index=0&id=b53c119a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53c119a",
  null
  
)

export default component.exports